import client from './client';

export default {
  fetchSelf() {
    return client.get('/users/self').end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/userAPI.js